import { Paper, Table, TableContainer } from '@mui/material'
import {
  ManualHoursReportingTableHead,
  ManualHoursReportingTableBody,
} from '@/features'
import { ManualHoursReport, ManualHoursHrReport } from '@/types'

export type ManualHoursReportingTableProps = {
  rows: (ManualHoursReport | ManualHoursHrReport)[]
  onOpenDetails: (id: number) => void
  showUserColumn: boolean
  showExportedColumn: boolean
}

export const ManualHoursReportingTable = ({
  rows,
  onOpenDetails,
  showUserColumn,
  showExportedColumn,
}: ManualHoursReportingTableProps): JSX.Element => (
  <TableContainer component={Paper}>
    <Table stickyHeader={true}>
      <ManualHoursReportingTableHead
        showUserColumn={showUserColumn}
        showExportedColumn={showExportedColumn}
      />
      <ManualHoursReportingTableBody
        rows={rows}
        onOpenDetails={onOpenDetails}
        showUserColumn={showUserColumn}
        showExportedColumn={showExportedColumn}
      />
    </Table>
  </TableContainer>
)
